import { render } from "./AutomationWizardOverviewContainer.vue?vue&type=template&id=687971c0&scoped=true"
import script from "./AutomationWizardOverviewContainer.vue?vue&type=script&lang=js"
export * from "./AutomationWizardOverviewContainer.vue?vue&type=script&lang=js"

import "./AutomationWizardOverviewContainer.vue?vue&type=style&index=0&id=687971c0&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-687971c0"]])

export default __exports__